Getaways = window.Getaways ?= {}
Getaways.BookingButton ?= {}

Getaways.BookingButton.init = (obj, done) ->
  calendarContainer = $("#travel-calendar")

  # add page focus event to the parent top button
  $('#redirect-to-subtotal-cluster').bind 'click', (ev) ->
    ev.preventDefault()
    $('html, body').animate({ scrollTop: calendarContainer.offset().top }, 400)

  $('.getaways-v2 a.book-button').bind 'click', (ev) ->
    ev.preventDefault()

  urlHashMap = Getaways.BookingButton.parseUrlHash(window.location.hash)
  if urlHashMap.check_in
    $('#redirect-to-subtotal-cluster').text(I18n.translate('js.modules.getaways.booking_calendar.calendar.confirm_dates'))
    $('.buy').append('<p class="confirm-dates" style="display:none"></p>')
  done()

Getaways.BookingButton.parseUrlHash = (urlHash) ->
  urlMap = {}
  params = urlHash.substring(1).split('&')
  for p in params
    splitParam = p.split('=')
    urlMap[splitParam[0]] = splitParam[1]
  urlMap


module.exports = Getaways.BookingButton
